import { CollaborationCaret } from "@tiptap/extension-collaboration-caret";
import { Plugin } from "@tiptap/pm/state";
import { yCursorPlugin } from "@tiptap/y-tiptap";

import type { Awareness } from "y-protocols/awareness";

/**
 * Broadcasts the local cursor to awareness via y-prosemirror's `yCursorPlugin`, but keeps
 * only its `view` (writing) — remote presence is drawn by the AwarenessCursors overlay.
 * Dropping its `state`/`decorations` avoids two things: rendering a decoration over a math
 * node (which re-parents the node-view and blurs the in-math caret), and its default
 * `user.name = "User: <id>"` (so anonymous users stay nameless and get no label).
 */
export const CollaborationCaretBroadcast = CollaborationCaret.extend({
  addProseMirrorPlugins() {
    const { awareness } = this.options.provider as { awareness: Awareness };
    awareness.setLocalStateField("user", this.options.user);

    const { spec } = yCursorPlugin(awareness) as Plugin;
    return [new Plugin({ key: spec.key, view: spec.view })];
  },
});
